// NOTICE: KAPTION-INTEGRATION
// Asistentes: which assistant users belong to an external provider (today only
// Salesforce Agentforce), so the conversation view can show a small
// "Agentforce" label next to the assistant name. Fetched once per account and
// shared by every caller; an empty list (flag off) renders nothing.
import { computed, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import KaptionAssistantsAPI from 'dashboard/api/kaptionAssistants';

// Brand names, identical in every locale.
export const PROVIDER_LABELS = {
  agentforce: 'Agentforce',
};

// accountId -> { assistants: [], promise }
const cache = reactive({});

export const resetKaptionAssistantLabels = () => {
  Object.keys(cache).forEach(key => delete cache[key]);
};

export const fetchKaptionAssistantLabels = accountId => {
  if (!accountId) return Promise.resolve([]);
  if (cache[accountId]) return cache[accountId].promise;

  const entry = { assistants: [], promise: null };
  cache[accountId] = entry;
  entry.promise = KaptionAssistantsAPI.getLabels()
    .then(({ data }) => {
      cache[accountId].assistants = Array.isArray(data?.assistants)
        ? data.assistants
        : [];
      return cache[accountId].assistants;
    })
    .catch(() => []);
  return entry.promise;
};

export function useKaptionAssistantLabels() {
  const store = useStore();
  const accountId = computed(() => store?.getters?.getCurrentAccountId);

  watch(accountId, id => fetchKaptionAssistantLabels(id), {
    immediate: true,
  });

  const assistants = computed(() => cache[accountId.value]?.assistants || []);

  const assistantFor = userId => {
    if (!userId) return null;
    return (
      assistants.value.find(item => Number(item.user_id) === Number(userId)) ||
      null
    );
  };

  // 'Agentforce' for an Agentforce assistant user, null otherwise.
  const providerLabelFor = userId => {
    const assistant = assistantFor(userId);
    if (!assistant) return null;
    return PROVIDER_LABELS[assistant.provider] || null;
  };

  return { assistants, assistantFor, providerLabelFor };
}
